import {
  Button,
  ButtonGroup,
  Dialog,
  FormGroup,
  Input,
  TimePicker,
  DatePicker,
  Select,
  SelectTree,
  Checkbox,
} from '@tencent/spaui';
import React, { useState, useEffect } from 'react';
import { RPCFactory } from '../../../utils/RequestUtil';

const MessageTypeEnum = {
  all: { value: 'all', desc: '全部客服', key: 'all' },
  some: { value: 'some', desc: '按条件筛选', key: 'some' },
};
const messageTypeData = [];
Object.keys(MessageTypeEnum).forEach((key) => {
  messageTypeData.push({ value: key, label: MessageTypeEnum[key].desc });
});

const SelectionItemComponent = (props) => {
  const { value, multiple, data, onClick } = props;
  const checked = value.includes(data.wxWorkUserId);

  return (
    <li className='selection-info' style={{ paddingLeft: '10px' }}>
      <Checkbox
          value='Checkbox'
          checked={checked}
          onChange={onClick}
      >
        <ww-open-data type="userName" openid={data.wxWorkUserId} />
      </Checkbox>
    </li>
  );
};

const ValueAreaComponent = (props) => {
  const { value, data, multiple, onOpen, open, placeholder } = props;

  return !value.length ? (
    <a onClick={onOpen} className="selection-single placeholder">
      <span className="selection-single-text">{placeholder}</span>
    </a>
  ) : (
    <a onClick={onOpen} className="selection-single">
      <span className="selection-single-text">
        {value.map((item, index) => (
          <span style={{ marginRight: '0px' }}>
            <ww-open-data type="userName" openid={item} />
            {index < value.length - 1 ? <span style={{ marginRight: '0px' }}>, </span> : null}
          </span>
        ))}
      </span>
    </a>
  );
};

const MessageDialog = (props) => {
  const { noticeId } = props.editData;
  const [wxWorkRole] = useState(window.pageProps.wxWorkRole);
  const [personList, setPersonList] = useState([]); // 所有人-from接口
  const [optionsTag, setOptionsTag] = useState([]); // 标签-from接口
  const [messageType, setMessageType] = useState('some'); // 客户范围

  const [sales, setSales] = useState({}); // 销售id

  const [noticeName, setNoticeName] = useState(noticeId ? props.editData.noticeName : '');
  const [noticeContent, setNoticeContent] = useState(noticeId ? props.editData.noticeContent : '');
  const [date, setDate] = useState();
  const [time, setTime] = useState();

  const [tags, setTags] = useState(noticeId ? props.editData.tagList : []);

  useEffect(() => {
    // 标签数据结构重组
    console.log('22222');
    RPCFactory.qwCustomer.getAllTag().done((data) => {
      const dealGroup = (group) => {
        const options = group.tag.map((t) => ({
          value: t.id,
          desc: t.name,
        }));
        return {
          options,
          value: group.groupId,
          desc: group.groupName,
        };
      };
      setOptionsTag(data.map(dealGroup));
    });
    console.log(props);
    if (noticeId) {
      const [date1, time1] = props.editData.expectSendTime.split(' ');
      setDate(date1);
      setTime(time1.slice(0, 5));
      if (props.editData.salesRangeType === 1 && props.editData.tagRangeType === 1) {
        setMessageType('all');
      } else {
        const obj = {};
        props.editData.salesList.map((item, index) => {
          obj[item] = { name: props.editData.salesListName };
        });
        setSales({ ...obj });
      }
    }
  }, []);

  useEffect(() => {
    RPCFactory.qwMessage
      .associateList()
      .done((data) => {
        console.log(data);
        setPersonList(data.entities);
      })
      .fail((ret, msg) => {
        window.alert(`服务器请求出错，出错信息：${msg}`);
      });
  }, []);

  const handleSubmit = () => {
    console.log(sales, Object.keys(sales));
    if (!noticeName || !noticeContent || !date || !time) {
      alert('提交信息填写不完整，请检查');
      return false;
    }
    if (wxWorkRole !== 3 && messageType === 'some' && sales.length === 0 && tags.length === 0) {
      alert('请至少选择一个筛选条件');
      return false;
    }
    const param = {
      noticeName,
      noticeContent,
      expectSendTime: `${date} ${time}:59`,

      salesRangeType:
        wxWorkRole !== 3 && (messageType === 'all' || (tags.length > 0 && Object.keys(sales).length === 0)) ? 1 : 2, // 1是全部，2是筛选
      salesList: wxWorkRole === 3 ? [window.pageProps.wxWorkUserId] : Object.keys(sales),

      tagRangeType:
        wxWorkRole !== 3 && (messageType === 'all' || (Object.keys(sales).length > 0 && tags.length === 0)) ? 1 : 2, // 1是全部，2是筛选
      tagList: tags,

      ...(noticeId === '' ? {} : { noticeId }),
    };
    const promise = !noticeId ? RPCFactory.qwMessage.noticeRuleAdd : RPCFactory.qwMessage.noticeRuleUpdate;
    promise(param)
      .done(() => {
        props.onSuccess();
      })
      .fail((code, msg) => {
        alert(msg);
      });
  };

  return (
    <Dialog
      backdrop
      hideFooter
      type="normal"
      className="modal-set-height"
      title={noticeId ? '编辑消息提醒' : '新建消息提醒'}
      style={{ width: '580px' }}
      {...props.props}
    >
      <div className="message-setting form-list-normal">
        <div className="lump lump-nohd">
          <div className="lump-bd">
            <ul className="infos">
              <li className="infolist">
                <span className="info-tt">消息名称</span>
                <div className="info-des">
                  <FormGroup>
                    <Input
                      placeholder="请输入消息名称"
                      value={noticeName}
                      onChange={(e, value) => {
                        console.log(value);
                        setNoticeName(value);
                      }}
                    />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt info-tt-read">提醒内容</span>
                <div className="info-des">
                  <FormGroup>
                    <Input
                      tagType="textarea"
                      placeholder="请输入文字内容"
                      value={noticeContent}
                      onChange={(e, value) => setNoticeContent(value)}
                    />
                  </FormGroup>
                </div>
              </li>

              {(wxWorkRole === 1 || wxWorkRole === 2) && (
                <li className="infolist">
                  <span className="info-tt">发送范围</span>
                  <div className="info-des">
                    <ButtonGroup
                      style={{ width: '500px !important' }}
                      data={messageTypeData}
                      value={messageType}
                      onChange={(event, value) => {
                        setMessageType(value);
                        if (value === 'all') {
                          setSales({});
                          setTags([]);
                        }
                      }}
                    />
                  </div>
                </li>
              )}
              {messageType === 'some' && (
                <li className="infolist">
                  <span className="info-tt">筛选条件</span>
                  <div className="info-des">
                    <FormGroup>
                      <div className="flex">
                        {/* 1 企微管理员  2企微客服经理 3 企微客服人员 */}
                        {[1, 2].includes(wxWorkRole) && (
                          <Select
                            clear
                            search={false}
                            placeholder="选择客服"
                            SelectionItemComponent={SelectionItemComponent}
                            ValueAreaComponent={ValueAreaComponent}
                            valueFieldName={'wxWorkUserId'}
                            data={personList}
                            multiple
                            value={Object.keys(sales)}
                            onChange={(event, value, item) => {
                              setSales(item);
                            }}
                          />
                        )}
                        {[1, 2].includes(wxWorkRole) && <span className="sp-hor"></span>}
                        {/* 1: 企微管理员, 2: 企微客服经理, 3: 企微客服人员, 4: 企微运营专员 */}
                        <SelectTree
                          placeholder="选择标签"
                          valueType="child"
                          showParentNodeLabel={false}
                          onChange={(e, value) => {
                            setTags(value);
                          }}
                          multiple
                          data={optionsTag || []}
                          value={tags || []}
                          style={{
                            width: '300px',
                          }}
                          dropStyle={{
                            width: '200px',
                          }}
                        />
                      </div>
                    </FormGroup>
                  </div>
                </li>
              )}
              <li className="infolist">
                <span className="info-tt">发送时间</span>
                <div className="info-des">
                  <div className="flex">
                    <DatePicker
                      input={true}
                      type="single"
                      date={date}
                      optionalStartRelativeDays={0}
                      optionalEndRelativeDays={1000}
                      onChange={(e, value) => {
                        setDate(value);
                      }}
                    />
                    <span className="sp-hor"></span>
                    <TimePicker
                      placeholder="请选择时间"
                      value={time}
                      onChange={(e, value) => {
                        setTime(value);
                      }}
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="btnline" style={{ 'padding-left': '170px', 'margin-top': '0px', marginBottom: '20px' }}>
          <Button displayType="default" onClick={props.onCancel}>
            取消
          </Button>
          <Button displayType="primary" onClick={handleSubmit}>
            确定
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default MessageDialog;
